import {
    UPDATE_SPEAKER_LIKES,
    IS_SPEAKER_LOADING,
    SET_AGENDA_SPEAKER_SESSIONS,
    SET_AGENDA_SPEAKER,
    SET_AGENDA_SPEAKER_LIKE_COUNT,
    RESET_SPEAKER_DATA,
    START_UPDATE_LIKE_SPEAKER_STATUS,
    FAILED_UPDATE_LIKE_SPEAKER_STATUS
} from '../constants/ActionTypes';

const initialState = {
    isLoading: true,
    speaker: null,
    sessions: {},
    speakerLikesCount: {
        entityId: 0,
        count: 0,
        disableLikeClick: false
    }
};

const SpeakerReducer = (state = initialState, action = null) => {
    switch (action.type) {
    case RESET_SPEAKER_DATA:
        return initialState;
    case UPDATE_SPEAKER_LIKES:
        return {
            ...state,
            speakerLikesCount: {
                ...state.speakerLikesCount,
                count: state.speakerLikesCount.count + action.payload.delta,
                disableLikeClick: false
            }
        };
    case IS_SPEAKER_LOADING:
        return {
            ...state,
            isLoading: action.isLoading
        };
    case SET_AGENDA_SPEAKER_SESSIONS:
        return {
            ...state,
            sessions: action.sessions
        };
    case SET_AGENDA_SPEAKER:
        return {
            ...state,
            speaker: action.speaker
        };
    case SET_AGENDA_SPEAKER_LIKE_COUNT:
        return {
            ...state,
            speakerLikesCount: {
                ...state.speakerLikesCount,
                ...action.speakerLikesCount
            }
        };
    case START_UPDATE_LIKE_SPEAKER_STATUS:
        return {
            ...state,
            speakerLikesCount: {
                ...state.speakerLikesCount,
                disableLikeClick: true
            }
        };
    case FAILED_UPDATE_LIKE_SPEAKER_STATUS:
        return {
            ...state,
            speakerLikesCount: {
                ...state.speakerLikesCount,
                disableLikeClick: false
            }
        };
    default:
        return state;
    }
};

export default SpeakerReducer;
